import { RouteType } from '@/Routes';
import { lazy } from 'react';

const SignupIndex = lazy(() => import('@/pages/signup'));
const Signup1 = lazy(() => import('@/pages/signup/1'));
const Signup2 = lazy(() => import('@/pages/signup/2'));
const Signup3 = lazy(() => import('@/pages/signup/3'));
const SignupComplete = lazy(() => import('@/pages/signup/complete'));

const ServerSignup: RouteType[] = [
  { path: '/signup', component: SignupIndex },
  { path: '/signup/1', component: Signup1 },
  { path: '/signup/2', component: Signup2 },
  { path: '/signup/3', component: Signup3 },
  { path: '/signup/complete', component: SignupComplete },
];

export default ServerSignup;
